var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "login-page" }, [
    _c("div", { staticClass: "login" }, [
      _c(
        "form",
        {
          staticClass: "login__content",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.loginEmail($event)
            }
          }
        },
        [
          _c("h1", { staticClass: "login__branding" }, [
            _vm._v("\n        Colonial Life\n      ")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "login__subtitle" }, [
            _vm._v("Tech Platform Assistant")
          ]),
          _vm._v(" "),
          !_vm.isLoggingIn && !_vm.serverResponse
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "login__intro" }, [
                    _vm._v(
                      "\n          Need help identifying an enrollment platform? Look up special features,\n          view side-by-side comparisons, and get recommendations through a guided\n          series of questions for your specific case. Enter your email to get started.\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "login__help" }, [
                    _vm._v(
                      "\n          Check your inbox for an email from us. Once you've verified your email,\n          you'll have access to this tool.\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("unum-textbox", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          // only cyberwoven.com or coloniallife.com domains
                          regex: /^[a-zA-Z0-9\'_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(coloniallife|coloniallifesales|unum|cyberwoven)\.com$/i
                        },
                        expression:
                          "{\n            required: true,\n            // only cyberwoven.com or coloniallife.com domains\n            regex: /^[a-zA-Z0-9\\'_.+-]+@(?:(?:[a-zA-Z0-9-]+\\.)?[a-zA-Z]+\\.)?(coloniallife|coloniallifesales|unum|cyberwoven)\\.com$/i\n          }"
                      }
                    ],
                    attrs: {
                      name: "loginEmail",
                      label: "Email Address",
                      "hide-label": true,
                      placeholder: "Enter your Colonial Life email address",
                      "data-vv-validate-on": "blur",
                      "data-vv-value-path": "loginEmail",
                      errorBag: _vm.errors
                    },
                    model: {
                      value: _vm.loginCred.email,
                      callback: function($$v) {
                        _vm.$set(_vm.loginCred, "email", $$v)
                      },
                      expression: "loginCred.email"
                    }
                  }),
                  _vm._v(" "),
                  _c("unum-button", [_vm._v("Log In")])
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.isLoggingIn && !_vm.serverResponse
        ? _c("div", { staticClass: "spinner login__loading" }, [
            _c("div", { staticClass: "dot1" }),
            _vm._v(" "),
            _c("div", { staticClass: "dot2" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggingIn && _vm.serverResponse
        ? _c("div", [
            _vm._v("\n      Email sent to "),
            _c("strong", [_vm._v(_vm._s(_vm.loginCred.email))]),
            _vm._v(". Check your inbox.\n    ")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 